<style lang="scss" scoped>
.wrapper {
  @apply fixed w-full items-center bg-white shadow-md top-0;
  z-index: 200;
  .header_mobile {
    @apply flex w-full items-center px-3 py-2 bg-white shadow-md;
   &__left {
     @apply w-4/12 text-blue text-xl;
   }
   &__logo {
     @apply w-6 mx-auto;
   }
   &__right {
     @apply w-4/12 flex items-center justify-end;
     >* {
       @apply mx-1;
     }
    .dropdown {
      @apply inline-block normal-case;
      #menu_help {
        @apply hidden;
      }
      .clickable {
        @apply w-5;
      }
      .menu {
        &__title {
          @apply font-semibold text-grayMedium border-grayLight border-b pb-2 p-0 m-0;
        }
        li {
          @apply p-1;
        }
        li>a {
          @apply flex text-grayMedium  ;
          .tutorial-icon {
            @apply w-4 mr-2;
          }

        }
      }
    }
    >a {
      @apply w-4;
    }
   }
  }
  >footer {
    @apply py-1;
  }
}
.app-integration-menu-item {
  display: block;
  margin-right: 0.9rem;
  padding-left: 0.1rem;
  width: 1rem;

  &__icon {
    width: 15px !important;
  }
}
</style>

<template>
  <div class="wrapper" id="header-mobile">
    <header class="header_mobile">
      <!-- <p v-if="fn_IS_DOCTOR()" class="header__subscription">
        <strong>Plano</strong>: <router-link to="/doctor/plans">{{ fn_IS_DOCTOR_FACILITIES() ? 'Facilities' : 'Pro' }}</router-link>
      </p> -->
      <div class="header_mobile__left">

      <button @click="$emit('toggle-menu', true)">
        <i class="hamburguer icon" :class="menuToggled ? 'icon-cross' : 'icon-menu'"></i>
      </button>
      </div>

      <div class="header_mobile__logo">
        <dr-vector
          :src="Logo"
          fill="gradient"
        />
      </div>

      <!-- <div class="header__nav header__nav--left">
        <dr-toggle-telemedicine v-if="false && offices.length > 0" />
      </div> -->

      <div class="header_mobile__right">
        <label for="menu_help" class="dropdown dropdown-right active">
          <input id="menu_help" type="checkbox" v-model="toggleHelp" />

          <dr-icon class="clickable w-10" name="help" color="#111"></dr-icon>

          <ul
            v-if="toggleHelp"
            v-click-outside="closeHelp"
            class="menu"
          >
            <li class="menu__title">
              Tutoriais
            </li>
            <li class="nav-item">
              <a @click.prevent="$emit('toggle-tutorial', '0')">
                <dr-icon
                  fill="blue"
                  name="usuarios"
                  class="tutorial-icon"
                />

                Meus dados
              </a>
            </li>

            <li class="nav-item">
              <a @click.prevent="$emit('toggle-tutorial', '1')">
                <dr-icon
                  fill="blue"
                  name="agenda"
                  class="tutorial-icon"
                />

                Propriedades de agenda
              </a>
            </li>

            <li class="nav-item">
              <a @click.prevent="$emit('toggle-tutorial', '2')">
                <dr-icon
                  fill="blue"
                  name="consultas"
                  class="tutorial-icon"
                />

                Realizando atendimento
              </a>
            </li>
          </ul>
        </label>

        <notifications v-if="false"  />

        <router-link :to="`/logout`">
          <dr-icon name="logout"></dr-icon>
        </router-link>
      </div>
    </header>
    <footer >
      <dr-office-select />
    </footer>
  </div>
</template>

<script>
import DrOfficeSelect from '@/components/layout/setOffice/officeSelectHeader'
import notifications from '@/components/notifications'
import DrToggleTelemedicine from '@/components/layout/appIntegration/toggleTelemedicine'
import { mapGetters } from 'vuex'
import Logo from '@/assets/img/Logo.svg'
export default {
  props: {
    menuToggled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    DrOfficeSelect,
    notifications
  },

  data () {
    return {
      toggleDoctorList: false,
      toggleProfile: false,
      toggleHelp: false,
      toggleMobileMenu: false,
      showTutorial: false,
      Logo
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices',
      appIntegration: 'getAppIntegration'
    }),

    isTablet () {
      return this.windowWidth <= 740
    },

    showIntegrationButton () {
      return this.fn_IS_DOCTOR() &&
        this.appIntegration &&
        this.appIntegration['is_active']
    }
  },

  watch: {
    outerToggleProfile (next) {
      this.toggleProfile = false
    }
  },

  methods: {
    closeTutorial (event) {
      this.showTutorial = false
    },
    closeHelp () {
      this.toggleHelp = false
    }
  }
}
</script>
